import { formatNumber } from "../data/essential";
import moment from "moment";
import CountdownTimer from "../../Component/Timer";
import { Link } from "react-router-dom";
const style = { color: "#FFF" };
const checkStatus = (reconciliationData) => {
  return reconciliationData.some((reconciliation) => reconciliation.status.id !== 3 && reconciliation.status.id !== 4)
}
export const reconciliationColumns = (reconciliationData) => {
  const columns = [
    {
      name: <div style={style}>Operator</div>,
      cell: () => "Galaxy Group",
    },
    {
      name: (
        <div style={style}>
          Reconc
          <br />
          iliation
          <br />
          Month
        </div>
      ),
      cell: (row) => row["reconciliationPeriod"],
      width: "80px",
    },
    {
      name: (
        <div style={style}>
          {" "}
          Scheduled
          <br /> Transfer
          <br />
          Time
        </div>
      ),
      cell: (row) =>
        moment(row["transferScheduledDate"]).format("DD-MM-YYYY H:mm:ss A"),
    },
    {
      name: <div style={style}> Collections</div>,
      cell: (row) => formatNumber(row["totalCollectionAmount"]),
      width: "102px",
    },
    {
      name: <div style={style}>Commission</div>,
      cell: (row) => formatNumber(row["totalCommissionAmount"]),
      width: "110px",
    },
    {
      name: (
        <div style={style}>
          Disbur-
          <br />
          sement
        </div>
      ),
      cell: (row) => formatNumber(row["totalDisbursementAmount"]),
    },
    {
      name: <div style={style}>Transfered</div>,
      cell: (row) => formatNumber(row["totalTransferedAmount"]),
    },
    {
      name: <div style={style}>Refunded</div>,
      cell: (row) => formatNumber(row["totalRefundedAmount"]),
    },
    {
      name: (
        <div style={style}>
          Collection
          <br /> Fee
        </div>
      ),
      cell: (row) => formatNumber(row["momoCollectionFeeAmount"]),
    },
    {
      name: <div style={style}>To be Paid</div>,
      cell: (row) => formatNumber(row["totalTobepaidAmount"]),
    },
    {
      name: <div style={style}>Paid</div>,
      cell: (row) => formatNumber(row["totalPaidAmount"]),
    },
    {
      name: <div style={style}>Transfer Id</div>,
      cell: (row) => row["transferId"],
    },
    {
      name: <div style={style}>Status</div>,
      cell: (row) => row["status"]["name"],
    },
    {
      name: <div style={style}>Time Left</div>,
      cell: (row) => {
        const targetDate = new Date(row?.transferScheduledDate);
        targetDate.setDate(targetDate.getDate());
        return (
          <div>
            <CountdownTimer targetDate={targetDate} />
          </div>
        );
      },
    },
    {
      name: checkStatus(reconciliationData) && <div style={style}>Reconciliation</div>,
      cell: (row) => {
        if (checkStatus(reconciliationData)) {
          return (
            <Link
              to={`/loggedin/reconciliation/${row?.reconciliationPeriod}/disbursements/${row?.id}`}
              className='d-flex justify-content-center'
              style={{ width: "100%" }}
            >
              {row.status.id !== 3 && row.status.id !== 4 && (
                <i
                  className='fa fa-eye'
                  style={{ color: "#124db1", cursor: "pointer" }}
                  title='View reconciliation details'
                />
              )}
            </Link>
          );
        } else {
          return null; // Return null if checkStatus is false
        }
      },
      width: "125px",
    },
  ];
  return columns;
};

export const reconciliationHeaders = [
  { label: "Operator", key: "operator" },
  { label: "Reconciliation Month", key: "reconciliationPeriod" },
  { label: "Schedurled Transfer Time", key: "transferScheduledDate" },
  { label: "Collections", key: "totalCollectionAmount" },
  { label: "Commission", key: "totalCommissionAmount" },
  { label: "Disbursement", key: "totalDisbursementAmount" },
  { label: "Transfered", key: "totalTransferedAmount" },
  { label: "Refunded", key: "totalRefundedAmount" },
  { label: "Collection Fee", key: "momoCollectionFeeAmount" },
  { label: "To be Paid", key: "totalTobepaidAmount" },
  { label: "Paid", key: "totalPaidAmount" },
  { label: "Transfer Id", key: "transferId" },
  { label: "Status", key: "status" },
];